import classNames from 'classnames'

import { checkStringQuestionMark } from 'ui-component-library/utils/helpers'

import type { LinkType } from 'types'
import { Props as FAQProps } from './FAQDetail'

import Accordion from '../Accordion'
import Button from 'content-components/_Primatives/Button'
import FAQAccordionDetails from './FAQAccordionDetails'
import FAQDetail from './FAQDetail'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import { useMediaQuery } from '../MediaQuery'
import Ruler from '../00-Primitives/Ruler'

import style from './style.scss'

type BaseFAQProps = Omit<FAQProps, 'moreText' | 'lessText'>

export type Props = {
  button?: LinkType
  className?: string
  headline: string
  lessText: string
  moreText: string
  questions: BaseFAQProps[]
}

function formatAccordionItems(questions: BaseFAQProps[]) {
  return questions.map((question) => {
    return {
      className: question.className,
      details: <FAQAccordionDetails questionText={question.questionText} />,
      summary: checkStringQuestionMark(question.headlineText),
    }
  })
}

function determineHiddenRulers(questions: BaseFAQProps[]): number[] {
  const length = questions.length
  const hiddenRulers = [length - 1]

  if (length % 2 === 0) {
    hiddenRulers.unshift(length - 2)
  }

  return hiddenRulers
}

function FAQModule(props: Props) {
  const { belowMobile } = useMediaQuery({ mobile: true })
  const { button, className, headline, lessText, moreText, questions } = props
  const hiddenRulers = determineHiddenRulers(questions)
  const accordionItems = formatAccordionItems(questions)

  return (
    <div className={classNames(style.wrapper, className)}>
      <Ruler className={style.ruler} />
      <HeadlineTwo className={style.headline}>{headline}</HeadlineTwo>
      {belowMobile ? (
        <Accordion
          className={style.accordion}
          items={accordionItems}
          showBottomBorders
          variant='white'
        />
      ) : (
        <div className={style.questionsContainer}>
          {questions.map((question, index) => (
            <FAQDetail
              key={`${question.headlineText}-${index}`}
              className={style.question}
              lessText={lessText}
              moreText={moreText}
              rulerClass={
                hiddenRulers.includes(index) ? style.questionHideRuler : ''
              }
              {...question}
            />
          ))}
        </div>
      )}
      {button && (
        <Button url={button.url} variant='primaryBlue'>
          {button.text}
        </Button>
      )}
    </div>
  )
}

export default FAQModule
